var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F622(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M36.2 13.316c-12.572 0-22.8 10.228-22.8 22.8 0 12.572 10.228 22.8 22.8 22.8 12.572 0 22.8-10.228 22.8-22.8 0-12.572-10.228-22.8-22.8-22.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D3F5",
    d: "M22.775 33.825c-1.077 1.101-3.115 3.487-3.293 5.916-.11 1.52 1.119 2.943 2.637 3.053a2.858 2.858 0 003.054-2.636c.177-2.43-1.493-5.086-2.398-6.334z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 23,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.5 48c1.877-3.833 5.824-6.197 10-6 3.834.18 7.293 2.493 9 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M20.387 41.63a2.8 2.8 0 01-.826-1.994c0-2.479 2.344-4.85 2.443-4.95a.53.53 0 01.75 0c.1.1 2.444 2.472 2.444 4.951h0a2.822 2.822 0 01-2.818 2.818c-.753 0-1.46-.293-1.993-.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 31a3.001 3.001 0 01-6 0c0-1.655 1.345-3 3-3s3 1.345 3 3M48 31a3.001 3.001 0 01-6 0c0-1.655 1.345-3 3-3s3 1.345 3 3"
  }))));
}
export default Svg1F622;